import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsDefined, IsInt, IsObject, IsOptional, IsString, Max, Min, ValidateNested } from 'class-validator';
import { SocialMediaDisplayAreaEnum, WebStoreExposeGroup } from '../interface';
import { PatchWebStoreThemePromotionsBarDto } from './PatchWebStoreThemePromotionsBarDto';
import { PatchWebStoreThemeSubscriptionDto } from './PatchWebStoreThemeSubscriptionDto';
export class PatchWebStoreMetadataThemeDto {
    constructor() {
        this.headerColor = '#fefefe';
        this.mainColor = '#044117';
        this.textBase = '#656365';
        this.textGradient = 'radial-gradient(circle at center, #e4b95d 35%, #845a22 75%)';
        this.notificationBg = '#044117';
        this.notificationColor = '#fff';
        this.ffBase = 'Montserrat, sans-serif';
        this.ffSecondary = 'var(--ff-base)';
        this.mainHoverColor = '#066323';
        this.navWeight = 'normal';
        this.grayColor = '#666';
        this.grayColor2 = '#666';
        this.titleStyle = 'normal';
        this.titlesTransform = 'none';
        this.titlesWeight = 'normal';
        this.menuPosition = 'flex-start';
        this.usernameColor = 'var(--main-color)';
        this.cartHeaderCountBg = 'var(--main-color)';
        this.cartHeaderCountColor = '#fff';
        this.headerBannerBg = 'var(--main-color)';
        this.headerBannerColor = '#fff';
        this.headerHeight = '60px';
        this.navColor = 'var(--text-base)';
        this.navColorMobile = 'var(--nav-color);';
        this.logoSize = '25px';
        this.buttonBg = 'var(--main-color)';
        this.buttonBgHover = 'var(--main-hover-color)';
        this.buttonColor = '#fff';
        this.buttonColorHover = '#fff';
        this.mainBg = '#f7f7f7';
        this.mainBgMobile = 'var(--main-bg)';
        this.modalPromotionColor = 'var(--main-color)';
        this.modalTitleColor = '#2d2b2d';
        this.navBg = 'rgba(242, 242, 242, 0.95)';
        this.navColorHover = '#000';
        this.navUnderline = 'var(--main-color)';
        this.ffHeader = 'var(--ff-base)';
        this.headerFontSize = '16px';
        this.headerFontWeight = '700';
        this.headerTextTransform = 'uppercase';
        this.toastSuccessBg = 'var(--main-color)';
        this.toastSuccessColor = '#fff';
        this.letterSpacing = 'normal';
        this.checkboxCheckedColor = 'var(--main-color)';
        this.ffHeroBlockTitle = 'var(--ff-base)';
        this.heroblockTitleFontSize = '60px';
        this.heroblockTitleFontWeight = '700';
        this.ffHeroBlockDescription = 'var(--ff-base)';
        this.categoryWeight = '400';
        this.categoryTitleFontSize = '24px';
        this.categoryTitleFontSizeDesktop = '30px';
        this.categoryColor = 'var(--main-color)';
        this.categoryTitleTextAlignMobile = 'center';
        this.backgroundCategory = 'none';
        this.categorySubtitleBackground = 'none';
        this.categoryTitleTextGradient = 'var(--text-gradient);';
        this.categoryTitlePadding = '5px 0 0 0';
        this.categoryTitlePaddingDesktop = '5px 0 25px 0';
        this.categorySubtitleColor = '#2d2b2d';
        this.categorySubtitleFontSize = '1em';
        this.categorySubtitleFontWeight = '400';
        this.categorySubtitleFontStyle = 'normal';
        this.categorySubtitleFontFamily = 'var(--ff-secondary)';
        this.categorySubtitleTextTransform = 'none';
        this.categorySubtitlePadding = '0';
        this.categorySubtitlePaddingDesktop = 'var(--category-subtitle-padding)';
        this.heroblockDescriptionFontWeight = '700';
        this.heroblockFontSize = '16px';
        this.heroBlockBannerRatio = '30%';
        this.heroBlockContentAlign = 'flex-start';
        this.heroblockJustifyContent = 'space-between';
        this.heroblockMargin = '0';
        this.heroblockTextAlign = 'left';
        this.heroblockTextColor = '#fff';
        this.heroblockLineHeight = 'inherit';
        this.heroblockBannerBrightness = '0.3';
        this.heroBlockPlainTextFF = 'var(--ff-base);';
        this.heroBlockBackgroundMobile = '#fff';
        this.heroblockMobileHeight = 'auto';
        this.heroBlockPlainTexFontSize = 'var(--heroblock-font-size);';
        this.heroBlockPlainTexFontWeight = 'var(--heroblock-description-font-weight);';
        this.heroBlockPlainTexFontStyle = 'italic';
        this.heroBlockPlainTexColor = 'var(--heroblock-text-color);';
        this.heroBlockPlainTexMargin = '0';
        this.heroBlockScheduleFF = 'var(--ff-base);';
        this.heroBlockScheduleFontSize = 'var(--heroblock-font-size);';
        this.heroBlockScheduleFontWeight = 'var(--heroblock-description-font-weight);';
        this.heroBlockScheduleFontStyle = 'italic';
        this.heroBlockScheduleColor = 'var(--heroblock-text-color);';
        this.heroBlockScheduleMargin = '0';
        this.heroBlockScheduleDaysFontSize = 'var(--heroblock-schedule-fontsize);';
        this.heroBlockScheduleDaysFontWeight = 'bold';
        this.heroBlockScheduleDaysColor = 'var(--heroblock-schedule-color);';
        this.heroBlockScheduleDaysTextTransform = 'uppercase';
        this.heroBlockScheduleDaysFontStyle = 'italic';
        this.heroBlockScheduleHoursFontSize = 'var(--heroblock-schedule-fontsize);';
        this.heroBlockScheduleHoursFontWeight = 'var(--heroblock-schedule-fontweight);';
        this.heroBlockScheduleHoursColor = 'var(--heroblock-schedule-color);';
        this.heroblockBannerHeight = '310px';
        this.storeitemBorder = '1px solid var(--storeitem-border-color)';
        this.storeitemBorderColor = '#f7f7f7';
        this.storeitemBorderHoverColor = 'var(--main-color)';
        this.storeitemBackgroundColor = '#ffffff';
        this.storeitemBoxShadow = '';
        this.storeitemBoxShadowHover = '';
        this.storeitemPriceGroupFontSize = '14px';
        this.storeitemPriceGroupFontWeight = '700';
        this.storeitemPriceGroupFontFamily = '';
        this.storeitemPriceGroupFontSizeDesktop = '18px';
        this.storeitemPriceGroupFontWeightDesktop = '400';
        this.storeitemPriceGroupFontFamilyDesktop = '';
        this.menuTextTransform = 'uppercase';
        this.menuTextFontSize = '14px';
        this.backCustomButtonFontSize = '12px';
        this.clearCartCustomButtonFontSize = '12px';
        this.itemDescriptionFontSize = '15px';
        this.itemDescriptionFontSizeMobile = '12px';
        this.itemDescriptionFontStyle = 'italic';
        this.itemDescriptionTextAlign = 'center';
        this.itemIngredientsFF = 'var(--ff-base);';
        this.itemIngredientsFontSize = '16px';
        this.itemIngredientsFontStyle = 'none';
        this.itemIngredientsFontWeight = '400';
        this.itemIngredientsColor = '#9f9f9f';
        this.itemIngredientsTextTransform = 'none';
        this.itemPriceFontStyle = 'italic';
        this.itemPriceTextTransform = 'none';
        this.headerNavHover = '#2d2b2d';
        this.titlesTransformTopCategories = 'var(--titles-transform)';
        this.storeitemCardHeight = '150px';
        this.ffTopCategories = 'var(--ff-base)';
        this.topCategoriesTextGradient = 'var(--text-gradient)';
        this.ffStoreItemMainTitle = 'var(--ff-base)';
        this.footerBg = '#2c2c2c';
        this.footerTextColor = '#7f7f7f';
        this.storeitemTitleTextAlign = 'center';
        this.storeitemTitleColor = '#2d2b2d';
        this.storeitemTextGradient = 'var(--text-gradient);';
        this.storeitemTitleSize = '1.313em';
        this.storeitemPriceAlign = 'center';
        this.storeitemPriceGroupAlign = 'space-between';
        this.usernameFontWeight = 'normal';
        this.usernametextTransform = 'none';
        this.titlesTransformItemMainTitle = 'var(--titles-transform)';
        this.headerCustomButtonBg = '#fff';
        this.headerCustomButtonBgHover = '#e7e7e7';
        this.headerCustomButtonColor = 'var(--text-base)';
        this.headerCustomButtonColorHover = 'var(--header-nav-hover)';
        this.headerCustomButtonFontSize = '16px';
        this.ffStoreItemMainSubtitle = 'var(--ff-base)';
        this.addonsValidateColor = '#666666';
        this.addonsSelectionColor = '#666666';
        this.promotionsBar = new PatchWebStoreThemePromotionsBarDto();
        this.orderTotal = {
            infoBox: {
                fontSize: '16px',
            },
        };
        this.itemDescriptionFormat = {
            desktop: {
                lineCount: 4,
            },
            mobile: {
                lineCount: 4,
            },
        };
        this.headerTopNavBar = {
            height: '40px',
            align: 'center',
            backGround: 'var(--nav-bg)',
            textColor: 'var(--nav-color)',
            textColorHover: 'var(--nav-color)',
            fontSize: 'var(--menu-text-fontSize)',
            fontWeight: 'var(--nav-weight)',
            textTransform: 'uppercase',
            activeLink: {
                underlineSide: 'top',
                underlineColor: 'var(--nav-underline)',
                textColor: 'var(--nav-color)',
                fontWeight: 'var(--nav-weight)',
            },
        };
        this.socialMedia = {
            [SocialMediaDisplayAreaEnum.FOOTER]: {
                fontSize: '12px',
                fontWeight: '300',
                textTransform: 'capitalize',
                textColor: '#C3C1C1',
                iconsColor: 'white',
            },
            [SocialMediaDisplayAreaEnum.SIDEBAR]: {
                fontSize: '14px',
                fontWeight: 'normal',
                textTransform: 'capitalize',
                textColor: 'black',
                iconsColor: 'black',
            },
        };
        this.orderToTable = {
            backgroundColor: 'var(--nav-bg)',
            fontSize: '15px',
            fontWeight: 'normal',
            textTransform: 'capitalize',
            textColor: 'var(--nav-color)',
            iconColor: 'var(--text-base)',
            badge: {
                color: 'var(--nav-color)',
                backgroundColor: 'var(--main-bg)',
            },
        };
        this.loyaltyHeaderColor = '#222222';
        this.storeitemTitleLetterSpacing = 'normal';
        this.storeitemDescriptionLetterSpacing = 'normal';
        this.storeitemDescriptionLineHeight = '20px';
        this.storeitemImageBorderRadiusMobile = '0';
        this.storeitemImageBorderRadiusDesktop = '0';
        this.storeitemBackgroundColorMobile = 'var(--storeitem-background-color)';
        this.storeitemImageWidthMobile = '';
        this.chevronBackgroundColorTopSellingScrollMenu = '#ffffff';
        this.sliderDotsItemActiveColor = '#141414';
        this.sliderDotsItemColor = '#cccccc';
        this.chevronColorTopSellingScrollMenu = '#141414';
        this.storeitemImageWidthDesktop = '50%';
        this.itemModifierGroupCardBorderColor = '#0441174d';
        this.itemModifierGroupRequiredTextColor = 'inherit';
        this.itemModifierGroupBadgeTextColorActive = '#fff';
        this.itemModifierGroupBadgeTextColorInactive = '#fff';
        this.itemModifierGroupBadgeBackgroundActive = '#999';
        this.itemModifierGroupBadgeBackgroundInactive = '#1F1F1F';
        this.menuVerticalGap = '20px';
        this.menuVerticalGapDesktop = '20px';
        this.menuHorizontalGap = '18px';
        this.mobileMenuHorizontalGap = '8px';
        this.menuColumnsNumberDesktop = 4;
        this.menuColumnsNumberMobile = 1;
        this.menuItemsAlign = 'start';
        this.menuItemsOneRowAlign = 'start';
        this.menuItemsDivider = '';
        this.orderStatusBanner = {
            background: '#fff',
            color: '#666',
        };
        this.discount = {
            fontSize: '15px',
            fontWeight: 'normal',
            fontFamily: 'var(--ff-base)',
            textColor: 'var(--main-color)',
        };
        this.subscription = new PatchWebStoreThemeSubscriptionDto();
        this.navigationBar = {
            background: 'var(--main-bg)',
            height: '31px',
            color: 'var(--main-color)',
            fontSize: '14px',
            lineHeight: '21px',
            fontWeight: 'normal',
            fontFamily: 'var(--ff-base)',
            textTransform: 'capitalize',
            badgeColor: 'var(--main-color)',
            badgeBg: 'var(--main-bg)',
            badgeWidth: '8px',
            badgeHeight: '8px',
            searchIconWidth: '16px',
            searchIconHeight: '16px',
        };
        this.navigationBarItemHover = {
            background: 'var(--main-bg)',
            color: 'var(--main-color)',
            fontSize: '14px',
            lineHeight: '21px',
            fontWeight: 'normal',
            fontFamily: 'var(--ff-base)',
            textTransform: 'capitalize',
            textDecoration: 'none',
        };
        this.navigationBarItemActive = {
            background: 'var(--main-bg)',
            color: 'var(--main-color)',
            fontSize: '14px',
            lineHeight: '21px',
            fontWeight: 'normal',
            fontFamily: 'var(--ff-base)',
            textTransform: 'capitalize',
            textDecoration: 'none',
        };
        this.navigationBarMobile = {
            background: 'var(--main-bg)',
            height: '40px',
            color: 'var(--main-color)',
            fontSize: '15px',
            lineHeight: '21px',
            fontWeight: 'normal',
            fontFamily: 'var(--ff-base)',
            textTransform: 'capitalize',
            badgeColor: 'var(--main-color)',
            badgeBg: 'var(--main-bg)',
            badgeWidth: '8px',
            badgeHeight: '8px',
            searchIconWidth: '20px',
            searchIconHeight: '20px',
        };
        this.menuListCategorySchedule = {
            background: 'var(--main-color)',
            color: '#fff',
            fontSize: '14px',
            fontWeight: 'bold',
            fontFamily: 'var(--ff-base)',
            textAlign: 'center',
        };
        this.menuListItemSchedule = {
            color: 'var(--storeitem-title-color)',
            fontSize: '12px',
            fontWeight: 'bold',
            fontFamily: 'var(--ff-base)',
            textAlign: 'center',
        };
        this.itemScheduleBlock = {
            background: 'var(--main-color)',
            color: '#fff',
            fontSize: '12px',
            fontWeight: 'bold',
            fontFamily: 'var(--ff-base)',
        };
        this.itemModalScheduleBlock = {
            background: 'var(--main-color)',
            color: '#fff',
            fontSize: '14px',
            fontWeight: 'bold',
            fontFamily: 'var(--ff-base)',
        };
        this.modal = {
            closeIcon: {
                color: '#666',
                hoverColor: '#666',
            },
            content: {
                color: '#666',
            },
        };
        this.prepTimeBlock = {
            background: 'var(--main-color)',
            color: '#fff',
            fontSize: '14px',
            fontWeight: 'bold',
            fontFamily: 'var(--ff-base)',
        };
        this.multiBrandCartBox = {
            background: 'var(--main-bg)',
            color: 'var(--notification-color)',
            fontSize: '14px',
            fontWeight: '700',
            fontFamily: 'var(--ff-base)',
            lineHeight: '18px',
        };
        this.prepTimeCartBlock = {
            color: 'var(--notification-color)',
            fontSize: '13px',
            fontWeight: 'bold',
            fontFamily: 'var(--ff-base)',
        };
    }
}
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "mainColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "textBase", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "textGradient", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "notificationBg", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "notificationColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "ffBase", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "ffSecondary", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "mainHoverColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "navWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "grayColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "grayColor2", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "titleStyle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "titlesTransform", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "titlesWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "menuPosition", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "usernameColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "cartHeaderCountBg", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "cartHeaderCountColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerBannerBg", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerBannerColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerHeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "navColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "navColorMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "logoSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "logoWidth", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "logoHeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "mobileLogoWidth", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "mobileLogoHeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "buttonBg", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "buttonBgHover", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "buttonColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "buttonColorHover", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "mainBg", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "mainBgMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "modalPromotionColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "modalTitleColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "navBg", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "navColorHover", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "navUnderline", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "ffHeader", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerTextTransform", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "toastSuccessBg", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "toastSuccessColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "letterSpacing", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "checkboxCheckedColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "ffHeroBlockTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockTitleFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockTitleFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "ffHeroBlockDescription", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categoryWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categoryTitleFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categoryTitleFontSizeDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categoryColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categoryTitleTextAlignMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "backgroundCategory", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categorySubtitleBackground", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categoryTitleTextGradient", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categoryTitlePadding", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categoryTitlePaddingDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categorySubtitleColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categorySubtitleFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categorySubtitleFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categorySubtitleFontStyle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categorySubtitleFontFamily", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categorySubtitleTextTransform", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categorySubtitlePadding", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "categorySubtitlePaddingDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockDescriptionFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockBannerRatio", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockContentAlign", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockJustifyContent", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockMargin", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockTextAlign", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockTextColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockLineHeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockBannerBrightness", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockPlainTextFF", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockBackgroundMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, default: 'auto' }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockMobileHeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockPlainTexFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockPlainTexFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockPlainTexFontStyle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockPlainTexColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockPlainTexMargin", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleFF", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleFontStyle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleMargin", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleDaysFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleDaysFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleDaysColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleDaysTextTransform", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleDaysFontStyle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleHoursFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleHoursFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroBlockScheduleHoursColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "heroblockBannerHeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemBorder", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemBorderColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemBorderHoverColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemBackgroundColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemBoxShadow", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemBoxShadowHover", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontFamily", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontSizeDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontWeightDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupFontFamilyDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "menuTextTransform", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "menuTextFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "backCustomButtonFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "clearCartCustomButtonFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemDescriptionFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemDescriptionFontSizeMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemDescriptionFontStyle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemDescriptionTextAlign", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemIngredientsFF", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemIngredientsFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemIngredientsFontStyle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemIngredientsFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemIngredientsColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemIngredientsTextTransform", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemPriceFontStyle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemPriceTextTransform", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerNavHover", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "titlesTransformTopCategories", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemCardHeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "ffTopCategories", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "topCategoriesTextGradient", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "ffStoreItemMainTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "footerBg", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "footerTextColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemTitleTextAlign", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemTitleColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemTextGradient", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemTitleSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemPriceAlign", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemPriceGroupAlign", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "usernameFontWeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "usernametextTransform", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "titlesTransformItemMainTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerCustomButtonBg", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerCustomButtonBgHover", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerCustomButtonColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerCustomButtonColorHover", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "headerCustomButtonFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "ffStoreItemMainSubtitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "addonsValidateColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "addonsSelectionColor", void 0);
__decorate([
    ApiPropertyOptional({ type: PatchWebStoreThemePromotionsBarDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    ValidateNested({ always: true }),
    Type(() => PatchWebStoreThemePromotionsBarDto),
    __metadata("design:type", PatchWebStoreThemePromotionsBarDto)
], PatchWebStoreMetadataThemeDto.prototype, "promotionsBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "orderTotalInfoBoxFontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    IsDefined({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "orderTotal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Array)
], PatchWebStoreMetadataThemeDto.prototype, "fontSoruces", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "itemDescriptionFormat", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "headerTopNavBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "socialMedia", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "orderToTable", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "loyaltyHeaderColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemTitleLetterSpacing", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemDescriptionLetterSpacing", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemDescriptionLineHeight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemImageBorderRadiusMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemImageBorderRadiusDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemBackgroundColorMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemImageWidthMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "chevronBackgroundColorTopSellingScrollMenu", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "sliderDotsItemActiveColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "sliderDotsItemColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "chevronColorTopSellingScrollMenu", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "storeitemImageWidthDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemModifierGroupCardBorderColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemModifierGroupRequiredTextColor", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemModifierGroupBadgeTextColorActive", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemModifierGroupBadgeTextColorInactive", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemModifierGroupBadgeBackgroundActive", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "itemModifierGroupBadgeBackgroundInactive", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "menuVerticalGap", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "menuVerticalGapDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "menuHorizontalGap", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, default: '8px' }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "mobileMenuHorizontalGap", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsInt({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Min(2, { always: true }),
    Max(5, { always: true }),
    __metadata("design:type", Number)
], PatchWebStoreMetadataThemeDto.prototype, "menuColumnsNumberDesktop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, default: 1 }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsInt({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Min(1, { always: true }),
    Max(2, { always: true }),
    __metadata("design:type", Number)
], PatchWebStoreMetadataThemeDto.prototype, "menuColumnsNumberMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "menuItemsAlign", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "menuItemsOneRowAlign", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional({ always: true }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(0, 255, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataThemeDto.prototype, "menuItemsDivider", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "orderStatusBanner", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "discount", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "loyaltyDisclaimer", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "loyaltyBadge", void 0);
__decorate([
    ApiPropertyOptional({ type: PatchWebStoreThemeSubscriptionDto }),
    Type(() => PatchWebStoreThemeSubscriptionDto),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    ValidateNested({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", PatchWebStoreThemeSubscriptionDto)
], PatchWebStoreMetadataThemeDto.prototype, "subscription", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "orderReminder", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "menuConcepts", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "navigationBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "navigationBarItemHover", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "navigationBarItemActive", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "navigationBarMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "menuListCategorySchedule", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "menuListItemSchedule", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "itemScheduleBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "itemModalScheduleBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "menuList", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "modal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "prepTimeBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "multiBrandCartBox", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataThemeDto.prototype, "prepTimeCartBlock", void 0);
//# sourceMappingURL=PatchWebStoreMetadataThemeDto.js.map